import { createGlobalStyle } from 'styled-components';

export const MarkdownStyles = createGlobalStyle`
  .markdown-content {
    .markdown-table {
      border-collapse: collapse;
      width: 100%;
      margin: 16px 0;
      font-size: 14px;
      line-height: 1.5;
      border: 1px solid #e5e7eb;
      background-color: white;
    }

    .markdown-thead {
      background-color: white;
      border-bottom: 2px solid #e5e7eb;
    }

    .markdown-th {
      border: 1px solid #e5e7eb;
      padding: 12px 16px;
      text-align: left;
      font-weight: 600;
      background-color: white;
    }

    .markdown-td {
      border: 1px solid #e5e7eb;
      padding: 12px 16px;
      text-align: left;
      background-color: white;
    }

    .markdown-tr {
      background-color: white;
      border-bottom: 1px solid #e5e7eb;

      &:nth-child(2n) {
        background-color: white;
      }

      &:hover {
        background-color: #f9fafb;
      }
    }

    // Additional styles for better table appearance
    .markdown-table-container {
      overflow-x: auto;
      max-width: 100%;
      background-color: white;
    }

    // Style adjustments for dark mode if needed
    @media (prefers-color-scheme: dark) {
      .markdown-table {
        border-color: #e5e7eb;
        background-color: white;
      }

      .markdown-thead {
        background-color: white;
      }

      .markdown-th,
      .markdown-td {
        border-color: #e5e7eb;
        background-color: white;
      }

      .markdown-tr {
        background-color: white;

        &:nth-child(2n) {
          background-color: white;
        }

        &:hover {
          background-color: #f9fafb;
        }
      }
    }

    .html-content {
        width: 100%;
      overflow-x: auto;

      // Add styles for other HTML elements
      p {
        margin: 1em 0;
      }

      h1, h2, h3, h4, h5, h6 {
        margin-top: 1.5em;
        margin-bottom: 1em;
      }

      ul, ol {
        margin: 1em 0;
        padding-left: 2em;
      }

      li {
        margin: 0.5em 0;
      }

      code {
        background-color: #f6f8fa;
        padding: 0.2em 0.4em;
        border-radius: 3px;
        font-family: monospace;
      }

      pre {
        background-color: #f6f8fa;
        padding: 1em;
        border-radius: 6px;
        overflow-x: auto;
      }
    }
  }
`; 